//@ts-check
'use strict';

/**
 * Odds Guide — quick-link pill bar scroller (CDN-1875 follow-up).
 *
 * On desktop the pill row is a single horizontal scroll strip (scrollbar
 * hidden). This adds prev/next arrow affordances: it reveals them only when the
 * row actually overflows (`.is-scrollable`), scrolls by ~80% of the visible
 * width per click, and toggles each arrow's disabled state at the ends.
 *
 * On mobile the pills wrap (no scroll), so the arrows stay hidden via CSS and
 * this script is inert there.
 *
 * The arrows are a decorative mouse affordance — the pill links themselves are
 * the accessible navigation (tabbing through them scrolls them into view), so
 * the buttons are aria-hidden + out of the tab order in the markup.
 *
 * Minimal, dependency-free, namespaced; a no-op when no pill bars are present.
 */
(function () {
	/** @type {HTMLElement[]} */
	const bars = Array.from(document.querySelectorAll('[data-odds-guide-pills]'));
	if (!bars.length) {
		return;
	}

	const EPS = 2;

	bars.forEach((bar) => {
		/** @type {HTMLElement | null} */
		const list = bar.querySelector('.odds-guide-pills__list');
		if (!list) {
			return;
		}

		const prevBtn = bar.querySelector('.odds-guide-pills__arrow--prev');
		const nextBtn = bar.querySelector('.odds-guide-pills__arrow--next');

		const isScrollable = () => list.scrollWidth > list.clientWidth + EPS;

		function sync() {
			const active = isScrollable();
			bar.classList.toggle('is-scrollable', active);
			if (!active) {
				return;
			}
			const max = list.scrollWidth - list.clientWidth;
			if (prevBtn) {
				prevBtn.toggleAttribute('disabled', list.scrollLeft <= EPS);
			}
			if (nextBtn) {
				nextBtn.toggleAttribute('disabled', list.scrollLeft >= max - EPS);
			}
		}

		/** @param {number} dir -1 = left, 1 = right */
		function step(dir) {
			const amount = Math.max(120, Math.round(list.clientWidth * 0.8));
			list.scrollBy({ left: dir * amount, behavior: 'smooth' });
		}

		if (prevBtn) {
			prevBtn.addEventListener('click', () => step(-1));
		}
		if (nextBtn) {
			nextBtn.addEventListener('click', () => step(1));
		}
		list.addEventListener('scroll', sync, { passive: true });
		window.addEventListener('resize', sync);

		sync();
	});
})();
